/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { withLoadingAndErrorStates } from '@guildeducationinc/mfe-utils';
import { logDataDogError } from '@src/utilities/datadog';

const MemberChatRemote = lazy(
	() => import(/* webpackChunkName: "remote/MemberChat" */ 'MemberChat/Chat')
);

export const MemberChat = withLoadingAndErrorStates({
	component: MemberChatRemote,
	errorAs: (error, componentStack) => {
		logDataDogError(error, 'MemberChatRemoteError', { componentStack });
		return <></>;
	},
});
